module.exports = __webpack_public_path__ + "static/grid-7a70547e10d11c670345a6425232dcd1.png";